<template>
  <div class="animated fadeIn">
    <!-- <loader v-if="loading"></loader> -->
    <b-card
      class="card-wrap"
      header="Tenants"
      border-variant="info"
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <b-row>
        <b-col md="6" class="my-1">
          <b-form-group label-cols-sm="3" class="mb-0">
            <b-input-group>
              <b-form-input placeholder="Type to Search" />
              <b-input-group-append>
                <eb-button
                  classic="mr-1 btn-primary"
                  text="Clear"
                  :disabled="!filter"
                  @click="filter = ''"
                ></eb-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <eb-button
            class="btn float-right mr-2"
            classic="mr-1 btn-primary"
            text="Create Tenant"
            icon="fa fa-plus-circle mr-1"
            iconSide="left"
            @click="$router.push({ path: '/tenant/create' })"
          ></eb-button>
        </b-col>
      </b-row>
      <div class="mt-3">
        <b-table
          :dark="dark"
          :hover="hover"
          :striped="striped"
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          responsive="sm"
          id="my-table"
          :items="tenants"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          thead-class="header"
          class="mt-3"
          :busy="loading"
          show-empty
          :fields="tenantColumns"
        >
          <template slot="name" slot-scope="data">
            <div class="table-row">{{ data.userName }}</div>
          </template>
          <template slot="action" slot-scope="data">
            <b-button
              size="sm"
              class="mr-2 mt-2"
              variant="primary"
              @click="ViewTenant(data.item)"
            >
              <i class="fa fa-eye"></i>
            </b-button>
            <b-button
              size="sm"
              class="mr-2 mt-2"
              variant="primary"
              @click="editTenant(data.item)"
            >
              <i class="fas fa-pencil-alt edit"></i>
            </b-button>
            <!-- <b-button
              size="sm"
              class="mr-2 mt-2"
              variant="danger"
              @click="deleteTenant(data.item)"
            >
              <i class="fa fa-trash bin"></i>
            </b-button> -->
          </template>
          <template slot="empty">
            <div v-if="loading" class="text-center">
              <span><b>Loading...</b></span>
            </div>
            <div v-else class="text-center">No data available.</div>
          </template>
        </b-table>
      </div>
      <div style="float: right">
        <b-pagination
          v-if="tenants.length > 0"
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="tenants.length"
          aria-controls="my-table"
          prev-text="Prev"
          next-text="Next"
          hide-goto-end-buttons
        ></b-pagination>
      </div>
      <!-- <p v-else style="text-align:center;padding-top:10px;">No data available!</p> -->
      <b-modal v-model="tenantModal" id="tenantModal" centered>
        <div slot="modal-header">{{ header }}</div>
        <div class="form-div">
          <label>User Name</label>
          <b-input v-model="tenant.userName" />
          <label>Email</label>
          <b-input v-model="tenant.email" />
          <label>Phone Number</label>
          <b-input v-model="tenant.phone" />
          <label>{{ context === "Add" ? "Password" : "New Password" }}</label>
          <b-input :type="'password'" v-model="tenant.password" />
        </div>
        <div slot="modal-footer">
          <b-button
            @click="submitModal"
            :disabled="
              tenant.userName === '' ||
              tenant.email === '' ||
              tenant.phone === '' ||
              tenant.password === ''
            "
            variant="primary"
            >Submit</b-button
          >
          <b-button @click="clearModal" class="ml-2" variant="secondary">Cancel</b-button>
        </div>
      </b-modal>
      <b-modal v-model="tenantModal1" id="tenantModal1" centered ok-only>
        <div slot="modal-header">{{ header }}</div>
        <div class="form-div">
          <label>User Name</label>
          <b-input v-model="tenant.userName" />
          <label>Email</label>
          <b-input v-model="tenant.email" />
          <label>Phone Number</label>
          <b-input v-model="tenant.phone" />
        </div>
      </b-modal>
    </b-card>
  </div>
</template>
<script>
import ebButton from "@/components/FormElements/Button";
import loader from "@/components/loader/nipigeloader.vue";
export default {
  name: "Tenant",
  components: {
    ebButton,
    loader,
  },
  data() {
    return {
      filter: "",
      perPage: 10,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      dark: false,
      fixed: false,
      currentPage: 1,
      loading: true,
      context: "Add",
      tenantModal: false,
      tenantModal1: false,
      header: "Edit Tenant",
      tenant: {},
      tenantColumns: [
        {
          key: "_id",
          sortable: true,
        },
        {
          key: "userName",
          sortable: true,
        },
        {
          key: "email",
        },
        {
          key: "action",
        },
      ],
    };
  },
  computed: {
    tenants() {
      let data = this.$store.getters["tenant/GetTenantList"];
      let tenantList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          let arrayObj = {
            _id: obj._id,
            userName: obj.authentication.userName,
            email: obj.authentication.email,
            phone: obj.authentication.phone,
            password: "",
            ...obj,
          };
          tenantList.push(arrayObj);
        });
        return tenantList;
      } else {
        this.loading = false;
        return [];
      }
    },
  },
  methods: {
    editTenant(data) {
      this.context = "Edit";
      this.header = "Edit Tenant";
      this.tenant = data;
      this.tenantModal = true;
    },
    ViewTenant(data) {
      this.context = "View";
      this.header = "View Tenant";
      this.tenant = data;
      this.tenantModal1 = true;
    },
    // async deleteTenant(data) {
    //   this.$swal({
    //     title: "Delete this Tenant?",
    //     text: "Are you sure? You won't be able to revert this!",
    //     type: "warning",
    //     showCancelButton: true,
    //     confirmButtonColor: "#3085d6",
    //     confirmButtonText: "Yes, Delete it!",
    //   }).then((result) => {
    //     if (result.value) {
    //       this.$store.dispatch().then((result) => {
    //         this.$toasted.success("Tenant Deleted Successfully");
    //         this.$store.dispatch("tenant/fetchTenantsList").catch((error) => {
    //           this.$toasted.error(error.message);
    //         });
    //       });
    //     }
    //   });
    //   this.$store.dispatch(
    //     "tenant/fetchTenantsList",
    //     this.$store.getters["auth/getUserID"]
    //   );
    // },
    submitModal() {
      if (this.context === "Add") {
        let dataObj = {
          authentication: {
            email: this.tenant.email,
            userName: this.tenant.userName,
            password: this.tenant.password,
            phone: this.tenant.phone,
          },
        };
        this.$store.dispatch("tenant/createTenant", dataObj).then(() => {
          this.$swal({
            title: "Success",
            text: "Tenant added successfully!!",
            type: "success",
          });
          this.clearModal();
        });
      } else if (this.context === "Edit") {
        let dataObj = {
          id: this.tenant._id,
          data: {
            authentication: {
              email: this.tenant.email,
              userName: this.tenant.userName,
              password: this.tenant.password,
              phone: this.tenant.phone,
            },
          },
        };
        this.$store.dispatch("tenant/updateTenantById", dataObj).then(() => {
          this.$swal({
            title: "Success",
            text: "Tenant updated successfully!!",
            type: "success",
          });
          this.clearModal();
        });
      }
    },
    clearModal() {
      this.tenantModal = false;
      this.tenantModal1 = false;
      this.tenant = {};
    },
    createTenant() {
      this.context = "Add";
      this.tenant = {
        userName: "",
        email: "",
        password: "",
        phone: "",
      };
      this.tenantModal = true;
      this.tenantModal1 = true;
      this.header = "Add Tenant";
    },
  },
  mounted() {
    this.loading = true;
    this.$store.dispatch("tenant/fetchTenantsList");
    this.loading = false;
  },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
